import React, { memo } from 'react';
import { L } from '@lib';
import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';

const { Option } = Select;

interface IProps {
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  placeholder?: string;
  onChange?:
    | ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void)
    | undefined;
}

export const YesNoSelect: React.FC<IProps> = memo(({ size, style, placeholder, onChange }) => {
  return (
    <Select style={{ width: 100, ...style }} defaultValue="All" placeholder={placeholder} size={size} onChange={onChange}>
      <Option value={undefined}>{L('All')}</Option>
      <Option value={1}>{L('Yes')}</Option>
      <Option value={0}>{L('No')}</Option>
    </Select>
  );
});
